import LicenseApi from './licenses.api';
import { raiseError } from '../messages/messages.actions';

export const LOAD_LICENSES_START = Symbol('LOAD_LICENSES_START');
export const LOAD_LICENSES_SUCCESS = Symbol('LOAD_LICENSES_SUCCESS');
export const LOAD_LICENSES_ERROR = Symbol('LOAD_LICENSES_ERROR');
export const LOAD_SINGLE_LICENSE_START = Symbol('LOAD_SINGLE_LICENSE_START');
export const LOAD_SINGLE_LICENSE_SUCCESS = Symbol('LOAD_LICENSES_SUCCESS');
export const LOAD_SINGLE_LICENSE_ERROR = Symbol('LOAD_LICENSES_ERROR');
export const POST_LICENSE_START = Symbol('POST_LICENSE_START');
export const POST_LICENSE_SUCCESS = Symbol('POST_LICENSE_SUCCESS');
export const POST_LICENSE_RESET = Symbol('POST_LICENSE_RESET');
export const EDIT_LICENSE_START = Symbol('EDIT_LICENSE_START');
export const EDIT_LICENSE_SUCCESS = Symbol('EDIT_LICENSE_SUCCESS');
export const DELETE_LICENSE_START = Symbol('DELETE_LICENSE_START');
export const DELETE_LICENSE_SUCCESS = Symbol('DELETE_LICENSE_SUCCESS');


const loadLicensesStart = key => ({ type: LOAD_LICENSES_START, key });
const loadLicensesSuccess = (key, response) => ({ type: LOAD_LICENSES_SUCCESS, response, key });
const loadLicensesError = key => ({ type: LOAD_LICENSES_ERROR, key });

const loadSingleLicensStart = key => ({ type: LOAD_SINGLE_LICENSE_START, key });
const loadSingleLicenseSuccess = (key, response) => ({ type: LOAD_SINGLE_LICENSE_SUCCESS, response, key });
const loadSingleLicenseError = key => ({ type: LOAD_SINGLE_LICENSE_ERROR, key });

const postLicenseStart = key => ({ type: POST_LICENSE_START, key });
const postLicenseSuccess = key => ({ type: POST_LICENSE_SUCCESS, key });

const editLicenseStart = key => ({ type: EDIT_LICENSE_START, key });
const editLicenseSuccess = key => ({ type: EDIT_LICENSE_SUCCESS, key });

const deleteLicenseStart = key => ({ type: DELETE_LICENSE_START, key });
const deleteLicenseSuccess = key => ({ type: DELETE_LICENSE_SUCCESS, key });

export function loadLicenses(key) {
  return function loadLicensesThunk(dispatch) {
    dispatch(loadLicensesStart(key));
    LicenseApi.getLicenses()
      .then(response => dispatch(loadLicensesSuccess(key, response)))
      .catch((error) => {
        dispatch(raiseError(error));
        dispatch(loadLicensesError(key));
      });
  };
}

export function loadSingleLicense(key, id) {
  return function loadSingleLicenseThunk(dispatch) {
    dispatch(loadSingleLicensStart(key));
    LicenseApi.getSingleLicense(id)
      .then(response => dispatch(loadSingleLicenseSuccess(key, response)))
      .catch((error) => {
        dispatch(raiseError(error));
        dispatch(loadSingleLicenseError(key));
      });
  };
}

export function saveLicense(license, key) {
  return function saveLicenseThunk(dispatch) {
    dispatch(postLicenseStart(key));
    LicenseApi.postLicense(license)
      .then(() => dispatch(postLicenseSuccess(key)))
      .catch(error => dispatch(raiseError(error)));
  };
}

export function editLicense(license, id, key) {
  return function editLicenseThunk(dispatch) {
    dispatch(editLicenseStart(key));
    LicenseApi.putLicense(license, id)
      .then(() => dispatch(editLicenseSuccess(key)))
      .catch(error => dispatch(raiseError(error)));
  };
}

export function postLicenseReset(key) {
  return { type: POST_LICENSE_RESET, key };
}

export function deleteLicense(key, id) {
  return function deleteLicenseThunk(dispatch) {
    dispatch(deleteLicenseStart(key));
    LicenseApi.deleteLicense(id)
      .then(() => dispatch(deleteLicenseSuccess(key)))
      .catch(error => dispatch(raiseError(error)));
  };
}
